import { HelperInitializer } from "../Helper/HelperInitializer";

/**
 * Creates/Initializes all needed animations on pageload
 */
export class AnimationFactoryInitializer {
	constructor() {
		const animationElements = document.querySelectorAll<Element>(".delo-animation");

		animationElements.forEach((animationElement) => {
			let animationType: string | null;

			if (!window.matchMedia("(max-width: 767px)").matches) {
				// Desktop
				animationType = animationElement.getAttribute("data-animation");
			} else {
				// Mobile
				animationType = animationElement.getAttribute("data-mobile-animation");
			}

			if (animationType == null) return;

			new Animation(animationElement, animationType);
		});
	}
}

export class Animation {
	element: Element;
	/** @property type: Contains the string which is used as a classname to add the animation */
	type: string;
	/** @property repeat: Whether the animation should be executed once or every time the element enters the viewport */
	repeat: boolean;

	constructor(element: Element, type: string) {
		this.element = element;
		this.type = type;
		this.repeat = element.getAttribute("data-animation-repeat") === "true";

		this.handleAnimation();
	}

	/**
	 * Creates the observer to add the corresponding animation class.
	 *
	 * @returns void
	 */
	handleAnimation(): void {
		const observer = HelperInitializer.createObserver((element: Element) => {
			element.classList.add(this.type);

			element.addEventListener("animationend", (e) => {
				element.classList.remove(this.type);
			});
		}, this.repeat);

		observer.observe(this.element);
	}
}
